import { render, staticRenderFns } from "./index.vue?vue&type=template&id=652a5dfa"
import script from "./invoiceLoader.js?vue&type=script&lang=js&external"
export * from "./invoiceLoader.js?vue&type=script&lang=js&external"
import style0 from "./invoiceLoader.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports